export default "__VITE_ASSET__vKzWjE5H__"